// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"103":"886c7f77b2649a7e","700":"2a62126a8ce2c949"}[chunkId] + ".js";
};